module.exports = __webpack_public_path__ + "img/pdf-logo.e95d53f1.svg";